import React from 'react';
import ProfileForm from '@/components/profile/ProfileForm';
import SubscriptionCard from '@/components/profile/SubscriptionCard';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function Profile() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile Settings</h1>
        <p className="text-gray-600">
          Manage your account settings and preferences
        </p>
        <div className="mt-4">
          <Button asChild>
            <Link to="/pricing">Upgrade Your Plan</Link>
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ProfileForm />
        <SubscriptionCard />
      </div>
    </div>
  );
}
